const setHeightMap = function () {
    $('.imagemap__image[data-animation="true"]').each(function () {
        const self = $(this);
        if (!self.find('img').prop('complete')) {
            self.find('img').on('load', function() {setHeightMap();});
        } else {
            const selfMaxWidth = self.css('maxWidth').replace(/[^-\d.]/g, '');
            const selfMaxHeight = self.css('maxHeight').replace(/[^-\d.]/g, '');
            const coef = (self.width() / selfMaxWidth);

            if (selfMaxWidth >= self.find('img').width()) {
                self.css('height', Math.ceil(selfMaxHeight * coef) );
            }
        }
        setCoordsMap(self.height, self);
    });
}

const setCoordsMap = function (height, image_map_img) {
    if (!image_map_img.prop('complete')) {
        image_map_img.on('load', () => setCoordsMap(0));
    } else {
        const wPercent = image_map_img.parent().width() / 100,
            hPercent = image_map_img.parent().height() / 100,
            maxWidth = image_map_img.parent().css('maxWidth').replace(/[^-\d.]/g, ''),
            maxHeight = image_map_img.parent().css('maxHeight').replace(/[^-\d.]/g, ''),
            c = 'coords';

        image_map_img.parent().find('area').each(function() {
            const $this = $(this);

            if (!$this.data(c)) {
                $this.data(c, $this.attr(c));
            }

            const coords = $this.data(c).split(','),
                newCoords = new Array(coords.length);
            for (let i = 0; i < newCoords.length; ++i) {
                if (i % 2 === 0) {
                    newCoords[i] = parseInt(coords[i] / maxWidth * 100 * wPercent);
                } else {
                    newCoords[i] = parseInt(coords[i] / maxHeight * 100 * hPercent) + height;
                }
            }
            $this.attr(c, newCoords.toString());
        });
    }
}

function getImageMapImg(self) {
    return self.parent().parent().find('img');
}

$(function () {
    if ($('.imagemap__image[data-animation="true"]').length) {
        $(window).on('load', setHeightMap);
        $(window).on('resize', setHeightMap);
    }

    $('.imagemap__popins__item').on('imagemap-popin-opened', (e) => {
        if (e.target.tagName === 'DIALOG') {
            e.target.open = true;
        }
    });

    $('.imagemap__popins__item').on('imagemap-popin-closed', (e) => {
        if (e.target.tagName === 'DIALOG') {
            e.target.open = false;
        }
    });

    if (window.outerWidth >= 601) {
        $('.imagemap__image[data-animation="true"]').on('mouseover', 'area, button.map_title', function () {
            var self = $(this);
            var image_map_img = getImageMapImg(self);
            var height = image_map_img.parent().height() * (self.index() + 1);
            setCoordsMap(height, image_map_img);
            image_map_img[0].style.marginTop = (-height) + 'px';
            image_map_img.parent().hide().show(0);
        }).on('mouseleave', 'area, button.map_title', function () {
            var self = $(this);
            var image_map_img = getImageMapImg(self);
            setCoordsMap(0, image_map_img);
            image_map_img[0].style.marginTop = '0px';
            image_map_img.parent().hide().show(0);
        });
    }

    $('.imagemap__image area[href]:not([href$="\\#"])').each(function () {
        $(this).parent().parent().append("<a href='" + $(this).attr('href') + "' class='map_link' title='" + $(this).attr('title') + "' target='" + $(this).attr('target') + "' >" + $(this).attr('title') + "</a>");
    });

    $('.sp-body').on('click', function (event) {
        if ($(this).hasClass('sp-body')) {
            event.stopPropagation();
        }
    });
});
